import { GET_DETAIL_NOTIFICATION, getDetailNotification } from 'api'
import { Icon, Typography } from 'components'
import { Icons, TypographyTypes } from 'interfaces'
import dayjs from 'lib/dayjs'
import React from 'react'
import { useQuery } from 'react-query'
import Cookies from 'universal-cookie'
import { CalendarEvent, formatLocalTime } from 'utils'

export const CalendarPanelPopoverLinkedPush: React.FC<{
	event: CalendarEvent
}> = ({ event }) => {
	const cookies = new Cookies()
	const userId = cookies.get('userId')
	const organizationId = cookies.get('organization_id')

	const eventDateTime = dayjs(
		formatLocalTime(event.publish_date, 'YYYY-MM-DDTHH:mm'),
		'YYYY-MM-DDTHH:mm'
	)
	const timeAgo = eventDateTime.fromNow()
	const copieAgo = event.card_expirated ? 'Expires' : 'Publish'

	const { data: dataNotification } = useQuery({
		queryKey: [GET_DETAIL_NOTIFICATION, userId, organizationId, event.id],
		queryFn: () => getDetailNotification(organizationId, event.id),
		refetchOnWindowFocus: false,
		enabled: !!event.has_notification
	})

	return (
		<div className="flex flex-col w-full bg-white rounded-lg overflow-y-auto max-h-[30rem] 1lg:max-h-[45rem]">
			<div className="flex w-full justify-between gap-4">
				<div className="flex justify-center items-center border border-1 border-[#C2EDF2] px-4 rounded-md w-1/2 gap-1">
					<Icon
						fillPath
						src={Icons.notificationsGeneric}
						className="w-5 h-5 flex-shrink-0 text-blue-1"
					/>
					<Typography
						title="Push"
						type={TypographyTypes.h3}
						fontLeading="14/24"
						className="text-blue-1"
					/>
				</div>
				<div className="flex justify-center items-center border border-1 border-gray-10 px-2 rounded-md gap-2 w-1/2">
					<div className="flex justify-center items-center flex-col">
						<Typography
							title="Publish"
							type={TypographyTypes.span}
							fontLeading="10/17"
							className="text-gray-9"
						/>
						<Typography
							title={dayjs(
								event.card_expirated
									? event.release_date || event.repeat_start_date
									: event.publish_date
							).format('MM/DD/YY')}
							type={TypographyTypes.span}
							fontLeading="14/24"
						/>
					</div>
				</div>
			</div>
			<div className="max-h-[580px] overflow-y-auto mt-2">
				<div className="mt-4 flex flex-row gap-2 items-center">
					<img
						src={event.organization_icon}
						alt={`${event.title}_icon`}
						className="w-[40px] h-[40px] shadow-md rounded-md"
					/>
					<div className="flex flex-col">
						<Typography
							title={event.organization_name}
							type={TypographyTypes.span}
							fontLeading="15/15"
							className="text-gray-9"
						/>
						<Typography
							title={
								timeAgo.includes('in') ? `${copieAgo} ${timeAgo}` : timeAgo
							}
							type={TypographyTypes.span}
							fontLeading="10/17"
							className="text-gray-9"
						/>
					</div>
				</div>
				<div className="flex flex-col gap-2 mt-3">
					<Typography
						title={dataNotification?.title ?? event.title}
						type={TypographyTypes.span}
						fontLeading="15/15"
						className="text-gray-9"
					/>
					<div
						className="text-[15px] text-black-1 font-normal font-Inter"
						// eslint-disable-next-line react/no-danger
						dangerouslySetInnerHTML={{
							__html: dataNotification?.message || ''
						}}
					/>
				</div>
			</div>
		</div>
	)
}
